import { render } from "./ConfirmationAlert.vue?vue&type=template&id=05791a1e&scoped=true"
import script from "./ConfirmationAlert.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ConfirmationAlert.vue?vue&type=script&charset=utf-8&lang=js"

import "./ConfirmationAlert.vue?vue&type=style&index=0&id=05791a1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05791a1e"]])

export default __exports__